import { AnsweringClient } from "../clients/answeringClient";

export interface RedirectControllerDelegate {
	authenticationSuccess(access: string, refresh: string): void;
	authenticationFailed(): void;
}

export class RedirectController {
	constructor(
		private delegate: RedirectControllerDelegate,
		private client = new AnsweringClient()
	) {}

	public async authenticateUser(token: string) {
		try {
			const result = await this.client.authenticate(token);

			const data = result.data;

			if (!data.accessToken || !data.refreshToken) {
				return this.delegate.authenticationFailed();
			}

			this.delegate.authenticationSuccess(data.accessToken, data.refreshToken);
		} catch (error) {
			this.delegate.authenticationFailed();
		}
	}
}
